import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface FeatureSqlRecord {
  PhaseNo: string;
  WorkItemId: number | null;
}

export interface PbiSqlRecord {
  TaskNo: string;
  WorkItemId: number | null;
}

export interface TimesheetEntryLinkRecord {
  BCEntryId: number;
  BCTimesheetId: string;
  IsZohoSynced: boolean;
}

export interface ZohoSetupProject {
  ProjectNo: string;
  Title: string;
  ZohoProjectId: string | null;
}

export interface ZohoSetupFeature {
  PhaseNo: string;
  Title: string;
  ZohoTaskId: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class SqlService {
  constructor(private httpClient: HttpClient) {}

  fetchFeatures() {
    return this.httpClient.get<FeatureSqlRecord[]>('/api/sql/features');
  }

  fetchPbis() {
    return this.httpClient.get<PbiSqlRecord[]>('/api/sql/pbis');
  }

  createTimesheetEntryLink(bcEntryId: number, bcTimesheetId: string, userId: string) {
    return this.httpClient.post<{ success: boolean }>('/api/sql/timesheet-entry-link', { bcEntryId, bcTimesheetId, userId });
  }

  deleteTimesheetEntryLink(bcEntryId: number, bcTimesheetId: string, userId: string) {
    return this.httpClient.delete<{ success: boolean }>(
      `/api/sql/timesheet-entry-link?bcEntryId=${bcEntryId}&bcTimesheetId=${encodeURIComponent(bcTimesheetId)}&userId=${encodeURIComponent(userId)}`,
    );
  }

  fetchPendingSyncEntries(userId: string) {
    return this.httpClient.get<{ BCEntryId: number; BCTimesheetId: string }[]>(
      `/api/sql/timesheet-entry-links/pending-sync?user_id=${encodeURIComponent(userId)}`,
    );
  }

  fetchTimesheetEntryLinks(userId: string) {
    return this.httpClient.get<TimesheetEntryLinkRecord[]>(`/api/sql/timesheet-entry-links?user_id=${encodeURIComponent(userId)}`);
  }

  resetTimesheetEntryLinkSync(bcEntryId: number, bcTimesheetId: string, userId: string) {
    return this.httpClient.patch<{ success: boolean }>('/api/sql/timesheet-entry-link/reset-sync', { bcEntryId, bcTimesheetId, userId });
  }

  fetchZohoSetupProjects() {
    return this.httpClient.get<ZohoSetupProject[]>('/api/sql/zoho-setup/projects');
  }

  fetchZohoSetupFeatures(projectNo: string) {
    return this.httpClient.get<ZohoSetupFeature[]>(`/api/sql/zoho-setup/projects/${encodeURIComponent(projectNo)}/phases`);
  }

  updateProjectZohoId(projectNo: string, zohoProjectId: string | null) {
    return this.httpClient.patch<{ success: boolean }>(`/api/sql/zoho-setup/projects/${encodeURIComponent(projectNo)}`, { zohoProjectId });
  }

  updateFeatureZohoId(projectNo: string, phaseNo: string, zohoTaskId: string | null) {
    return this.httpClient.patch<{ success: boolean }>(
      `/api/sql/zoho-setup/projects/${encodeURIComponent(projectNo)}/features/${encodeURIComponent(phaseNo)}`,
      { zohoTaskId },
    );
  }

  syncTimesheetToZoho(userEmail: string) {
    return this.httpClient.post<{ synced: number; failed: number; errors: string[] }>('/api/sync/zoho-timesheet', { user_email: userEmail });
  }
}
